import { render, staticRenderFns } from "./mostViewed.vue?vue&type=template&id=131792a5&scoped=true&"
import script from "./mostViewed.vue?vue&type=script&lang=js&"
export * from "./mostViewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131792a5",
  null
  
)

export default component.exports